export const DEFAULT_PAGE = 1;

export const DEFAULT_PAGE_SIZE = 12;

export const PAGE_SIZE_OPTIONS = [12, 24, 48] as const;

export type PageSizeOption = (typeof PAGE_SIZE_OPTIONS)[number];

